<div class="page-details-view-container" *ngIf="pageObject" fxLayout="column" fxLayoutGap="15px" >

  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).file_manager.write " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="60" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>

        <div fxLayout="row">
          <h3>Dane</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

          <div fxLayout="row" >
            <app-detail fxFlex="100" header="Nazwa" [value]="pageObject.name"></app-detail>
          </div>

        </div>


        <div fxLayout="column" fxFlex.lt-md="100" fxLayoutGap="15px">
          <div fxFlex="100" fxLayoutGap="15px">
            <ng-container *ngFor="let postDetails of pageObject.pageDetails; let i = index">
              <HR SIZE=1 >
              <div fxLayout="row" fxLayoutGap="15px" >
                <div *ngIf="postDetails.pageDetailType === 'TEXT'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >

                    <h3>{{ i + 1 }}. Pole tekstowe</h3>

                    <div  fxLayout="row"  fxFlex="100">
                      <div style=" max-height:300px; overflow: auto; white-space: normal; word-wrap: break-word;" fxFlex="94"  [innerHTML]="postDetails.pageDetailText"></div>
                    </div>
                  </div >
                </div>

                <div *ngIf="postDetails.pageDetailType === 'MOVIE'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >

                    <h3>{{ i + 1 }}. Film</h3>

                    <div  fxLayout="row"  fxFlex="100">
                      <app-detail fxFlex="100" header="Link " [value]="postDetails.pageDetailMovieLink"></app-detail>
                    </div>
                  </div >
                </div>


                <div *ngIf=" postDetails.pageDetailType === 'GRAPHICS'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >
                    <div  fxLayout="row"   fxFlex="100" >
                      <div   fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                        <h3>{{ i + 1 }}. Grafika</h3>
                      </div>
                    </div>
                    <div  fxLayout="row"  fxFlex="90">
                      <img class=" avatar-360" src="/rest/crm/cdn/file/{{postDetails.pageDetailFileLocation}}/image/{{postDetails.pageDetailFilename}}" alt="Zdjęcie"/>
                    </div>
                    <div fxLayout="row" fxLayoutGap="15px">
                      <app-detail fxFlex="100" header="Link CTA" [value]="postDetails.pageDetailCtaLink"></app-detail>
                    </div>
                  </div >
                </div>

                <div *ngIf="postDetails.pageDetailType === 'CTA'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >
                    <div  fxLayout="row"   fxFlex="100" >
                      <div  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                        <h3>{{ i + 1 }}. CTA</h3>
                      </div>
                    </div>
                    <div  fxLayout="row"  fxFlex="100">
                      <div  fxLayout="column"   fxFlex="100" >
                        <div fxLayout="row" fxLayoutGap="15px">
                          <app-detail fxFlex="50" header="Nagłówek CTA" [value]="postDetails.pageDetailCtaHeadline"></app-detail>
                          <app-detail fxFlex="50" header="Tekst CTA" [value]="postDetails.pageDetailCtaText"></app-detail>
                        </div>
                        <div fxLayout="row" fxLayoutGap="15px">
                          <app-detail fxFlex="50" header="Link CTA" [value]="postDetails.pageDetailCtaLink"></app-detail>
                          <app-detail fxFlex="50" header="Przycisk CTA" [value]="postDetails.pageDetailCtaButton"></app-detail>
                        </div>

                      </div>
                    </div>
                  </div>
                </div >
                <div *ngIf="postDetails.pageDetailType === 'TABLE'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >

                    <h3>{{ i + 1 }}. TABELA</h3>

                    <div  fxLayout="row"  fxFlex="100">
                      <div fxLayout="column"  style=" max-height:300px; overflow: auto; white-space: normal; word-wrap: break-word;" fxFlex="{{postDetails.pageTableColumn === 3 ? 33: 50}}"  [innerHTML]="postDetails.pageDetailText"></div>

                      <div fxLayout="column"  style=" max-height:300px; overflow: auto; white-space: normal; word-wrap: break-word;" fxFlex="{{postDetails.pageTableColumn === 3 ? 33: 50}}"  [innerHTML]="postDetails.pageDetailTextSecond"></div>

                      <div *ngIf="postDetails.pageTableColumn === 3 " fxLayout="column"  style=" max-height:300px; overflow: auto; white-space: normal; word-wrap: break-word;" fxFlex="33"  [innerHTML]="postDetails.pageDetailTextThird"></div>
                    </div>
                  </div >
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </mat-card>


    </div>


    <div fxLayout="column" fxFlex="40" fxFlex.lt-md="100" fxLayoutGap="15px">

      <mat-card>

        <div fxLayout="row">
          <h3>Kontakt</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <ng-container *ngFor="let users of pageObject.users; let i = index">
              <div fxLayout="row" fxLayoutGap="15px">
                <span fxFlex="5">{{i+1}}.</span>
                <app-detail fxFlex="47" header="Imie i nazwisko">{{users.usersName}}</app-detail>
                <app-detail fxFlex="47" header="Stanowisko">{{users.usersPosition}}</app-detail>

              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <span fxFlex="5"></span>
                <app-detail fxFlex="47" header="Numer telefonu">{{users.usersPhone}}</app-detail>
                <app-detail fxFlex="47" header="Email">{{users.usersEmail}}</app-detail>

              </div>
            </ng-container>
          </div>
        </div>

      </mat-card>

      <mat-card>
        <div fxLayout="row">
          <h3>Uprawnienia</h3>
        </div>



        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="50">
            <app-detail-bool fxFlex="100" header="Partner" [value]="pageObject.permissionPartner"></app-detail-bool>
          </div>
          <div  fxFlex="50">
            <app-detail-bool fxFlex="100" header="OFWCA" [value]="pageObject.permissionOfwca"></app-detail-bool>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">
              <div fxFlex="100">
                <app-detail header=" Tagi Partnera">
                  <mat-chip-list>
                    <ng-container *ngFor="let tagPartner of permissionTagPartner">
                      <mat-chip  selected>{{tagPartner.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" >
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header=" Rejestracjie ">
                  <mat-chip-list>
                    <ng-container *ngFor="let ic of permissionRegistration">
                      <mat-chip  selected>{{ic.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>
          </div>
        </div>

      </mat-card>

    </div>
  </div>
</div>
